export default __webpack_public_path__ + "static/media/geen.a8881668.svg";